import { DEVICES } from "../constants";

type Args = {
	orientation?: {
		[key in keyof typeof DEVICES]?: string;
	};
	justification?: Args["orientation"];
	alignment?: Args["orientation"];
};

type Result = {
	[key in keyof typeof DEVICES]?: {
		[key: string]: boolean;
	};
};
const dynamicClassNames = (args: Args): Result => {
	const { orientation, justification, alignment } = args;
	let classNames: Result = {};
	for (const device in DEVICES) {
		const suffix =
			"tablet" === device ? "-md" : "mobile" === device ? "-sm" : "";
		const _orientation = orientation?.[device];
		const _justification = justification?.[device];
		const _alignment = alignment?.[device];
		if (_orientation) {
			if (!classNames?.[device]) {
				classNames[device] = {};
			}
			classNames[device][`is-${_orientation}${suffix}`] = true;
		}
		if (_justification) {
			if (!classNames?.[device]) {
				classNames[device] = {};
			}
			classNames[device][`justify-${_justification}${suffix}`] = true;
		}
		if (_alignment) {
			if (!classNames?.[device]) {
				classNames[device] = {};
			}
			classNames[device][`align-${_alignment}${suffix}`] = true;
		}
	}

	return classNames;
};

export default dynamicClassNames;
